import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>DSC.JSC</h3>
            <p>Công ty Cổ phần Khảo sát Thiết kế và Dịch vụ Thương mại Miền Bắc</p>
            <p>Chuyên nghiệp - Uy tín - Chất lượng</p>
          </div>
          
          <div className="footer-section">
            <h4>Liên kết nhanh</h4>
            <ul>
              <li><Link to="/">Trang chủ</Link></li>
              <li><Link to="/about">Giới thiệu</Link></li>
              <li><Link to="/services">Dịch vụ</Link></li>
              <li><Link to="/equipment">Thiết bị</Link></li>
              <li><Link to="/projects">Dự án</Link></li>
              <li><Link to="/careers">Tuyển dụng</Link></li>
              <li><Link to="/contact">Liên hệ</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Dịch vụ chính</h4>
            <ul>
              <li>Khảo sát địa hình</li>
              <li>Thiết kế kỹ thuật</li>
              <li>Tư vấn xây dựng</li>
              <li>Dịch vụ thương mại</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Thông tin liên hệ</h4>
            <p>📍 Số 4/A1 Chung cư Tinh Thành Quốc tế, KĐT Cựu Viên, P. Kiến An, TP.Hải Phòng</p>
            <p>📞 Tel/Fax: 0225.3920691</p>
            <p>📧 mienbacdsc@gmail.com</p>
            <p>🕒 T2-T6: 8:00 - 17:00</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 DSC.JSC - Trắc địa Hải Phòng. Tất cả quyền được bảo lưu.</p>
          <p>Website: tracdiahaiphong.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;